'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

let Devices = /*#__PURE__*/function (Devices) {
  Devices["MOBILE"] = "Mobile";
  Devices["DESKTOP"] = "Desktop";
  return Devices;
}({});
let TreeNodeTypes = /*#__PURE__*/function (TreeNodeTypes) {
  TreeNodeTypes["VIEW"] = "View";
  TreeNodeTypes["ROW"] = "Row";
  TreeNodeTypes["COL"] = "Col";
  TreeNodeTypes["FEATURE"] = "Feature";
  return TreeNodeTypes;
}({});
let FeatureLayout = /*#__PURE__*/function (FeatureLayout) {
  FeatureLayout["PORTRAIT"] = "PORTRAIT";
  FeatureLayout["LANDSCAPE"] = "LANDSCAPE";
  return FeatureLayout;
}({});
let ConditionType = /*#__PURE__*/function (ConditionType) {
  ConditionType["SHIPMENT_STATUS"] = "SHIPMENT_STATUS";
  ConditionType["SUB_STATUS"] = "SUB_STATUS";
  ConditionType["CARRIER_MONIKER"] = "CARRIER_MONIKER";
  ConditionType["CATEGORY"] = "CATEGORY";
  return ConditionType;
}({});
let ConditionOperator = /*#__PURE__*/function (ConditionOperator) {
  ConditionOperator["EQ"] = "EQ";
  ConditionOperator["NEQ"] = "NEQ";
  ConditionOperator["IN"] = "IN";
  return ConditionOperator;
}({});
let ShipmentStatusConditionStatus = /*#__PURE__*/function (ShipmentStatusConditionStatus) {
  ShipmentStatusConditionStatus["JUSTSHIPPED"] = "JUSTSHIPPED";
  ShipmentStatusConditionStatus["INTRANSIT"] = "INTRANSIT";
  ShipmentStatusConditionStatus["DELIVERED"] = "DELIVERED";
  ShipmentStatusConditionStatus["EXCEPTION"] = "EXCEPTION";
  ShipmentStatusConditionStatus["PROCESSING"] = "PROCESSING";
  ShipmentStatusConditionStatus["PRESHIPMENT0"] = "PRESHIPMENT0";
  ShipmentStatusConditionStatus["PRESHIPMENT1"] = "PRESHIPMENT1";
  ShipmentStatusConditionStatus["PRESHIPMENT2"] = "PRESHIPMENT2";
  ShipmentStatusConditionStatus["PRESHIPMENT3"] = "PRESHIPMENT3";
  ShipmentStatusConditionStatus["PRESHIPMENT4"] = "PRESHIPMENT4";
  ShipmentStatusConditionStatus["PRESHIPMENT5"] = "PRESHIPMENT5";
  ShipmentStatusConditionStatus["PRESHIPMENT6"] = "PRESHIPMENT6";
  ShipmentStatusConditionStatus["PRESHIPMENT7"] = "PRESHIPMENT7";
  ShipmentStatusConditionStatus["PRESHIPMENT8"] = "PRESHIPMENT8";
  ShipmentStatusConditionStatus["PRESHIPMENT9"] = "PRESHIPMENT9";
  ShipmentStatusConditionStatus["BOPISPROCESSING"] = "BOPISPROCESSING";
  ShipmentStatusConditionStatus["BOPISDELAYED"] = "BOPISDELAYED";
  ShipmentStatusConditionStatus["BOPISREADYFORPICKUP"] = "BOPISREADYFORPICKUP";
  ShipmentStatusConditionStatus["BOPISPICKEDUP"] = "BOPISPICKEDUP";
  ShipmentStatusConditionStatus["BOPISCANCELLED"] = "BOPISCANCELED";
  ShipmentStatusConditionStatus["LDORDERPLACED"] = "LDORDERPLACED";
  ShipmentStatusConditionStatus["LDPICKUPINPROGRESS"] = "LDPICKUPINPROGRESS";
  ShipmentStatusConditionStatus["LDONITSWAY"] = "LDONITSWAY";
  ShipmentStatusConditionStatus["LDDELIVERED"] = "LDDELIVERED";
  ShipmentStatusConditionStatus["LDEXCEPTION"] = "LDEXCEPTION";
  ShipmentStatusConditionStatus["HPUSCHEDULED"] = "HPUSCHEDULED";
  ShipmentStatusConditionStatus["HPUPICKUPINPROGRESS"] = "HPUPICKUPINPROGRESS";
  ShipmentStatusConditionStatus["HPUPICKEDUP"] = "HPUPICKEDUP";
  ShipmentStatusConditionStatus["HPUEXCEPTION"] = "HPUEXCEPTION";
  return ShipmentStatusConditionStatus;
}({});
let ShipmentSubStatusConditionStatus = /*#__PURE__*/function (ShipmentSubStatusConditionStatus) {
  ShipmentSubStatusConditionStatus["SHPD"] = "SHPD";
  ShipmentSubStatusConditionStatus["INTR"] = "INTR";
  ShipmentSubStatusConditionStatus["OFDL"] = "OFDL";
  ShipmentSubStatusConditionStatus["DLVD"] = "DLVD";
  ShipmentSubStatusConditionStatus["DLPP"] = "DLPP";
  ShipmentSubStatusConditionStatus["PUBC"] = "PUBC";
  ShipmentSubStatusConditionStatus["ITTS"] = "ITTS";
  ShipmentSubStatusConditionStatus["ITPP"] = "ITPP";
  ShipmentSubStatusConditionStatus["DLTS"] = "DLTS";
  ShipmentSubStatusConditionStatus["EXCP"] = "EXCP";
  ShipmentSubStatusConditionStatus["UNDL"] = "UNDL";
  ShipmentSubStatusConditionStatus["BOSS"] = "BOSS";
  ShipmentSubStatusConditionStatus["BOPIS"] = "BOPIS";
  ShipmentSubStatusConditionStatus["UNKN"] = "UNKN";
  ShipmentSubStatusConditionStatus["SHPD_SDD_101"] = "SHPD_SDD_101";
  ShipmentSubStatusConditionStatus["SHPD_SDD_201"] = "SHPD_SDD_201";
  ShipmentSubStatusConditionStatus["SHPD_SDD_280"] = "SHPD_SDD_280";
  ShipmentSubStatusConditionStatus["SHPD_SDD_281"] = "SHPD_SDD_281";
  ShipmentSubStatusConditionStatus["INTR_SDD_311"] = "INTR_SDD_311";
  ShipmentSubStatusConditionStatus["OFDL_SDD_400"] = "OFDL_SDD_400";
  ShipmentSubStatusConditionStatus["OFDL_SDD_403"] = "OFDL_SDD_403";
  ShipmentSubStatusConditionStatus["DLVD_SDD_500"] = "DLVD_SDD_500";
  ShipmentSubStatusConditionStatus["UNDL_SDD_700"] = "UNDL_SDD_700";
  ShipmentSubStatusConditionStatus["EXCP_SDD_800"] = "EXCP_SDD_800";
  return ShipmentSubStatusConditionStatus;
}({});

// Default status for a track page. This is just a fail safe. Actual
// setting of a "default tracking status" is done further upstream
const DEFAULT_NARVAR_STATUS = ShipmentStatusConditionStatus.JUSTSHIPPED;
let CarrierConditionMoniker = /*#__PURE__*/function (CarrierConditionMoniker) {
  CarrierConditionMoniker["UPS"] = "ups";
  CarrierConditionMoniker["FEDEX"] = "fedex";
  CarrierConditionMoniker["METRO"] = "metro";
  CarrierConditionMoniker["PILOT"] = "pilot";
  return CarrierConditionMoniker;
}({});
let CategoryConditionCategory = /*#__PURE__*/function (CategoryConditionCategory) {
  CategoryConditionCategory["SHARING"] = "sharing";
  return CategoryConditionCategory;
}({});

exports.CarrierConditionMoniker = CarrierConditionMoniker;
exports.CategoryConditionCategory = CategoryConditionCategory;
exports.ConditionOperator = ConditionOperator;
exports.ConditionType = ConditionType;
exports.DEFAULT_NARVAR_STATUS = DEFAULT_NARVAR_STATUS;
exports.Devices = Devices;
exports.FeatureLayout = FeatureLayout;
exports.ShipmentStatusConditionStatus = ShipmentStatusConditionStatus;
exports.ShipmentSubStatusConditionStatus = ShipmentSubStatusConditionStatus;
exports.TreeNodeTypes = TreeNodeTypes;
